import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import erikaImg from '../assets/erikaImg.jpg';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    marginTop: '6.25rem'
  },
  textCont: {
    width: '51%',
    [theme.breakpoints.down('sm')]: {
      width: '75%'
    }
  },
  erikaImg: {
    width: '100%',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  imgSec: {
    flexWrap: 'nowrap',
    marginTop: '2.6rem',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    }
  },
  imgCap: {
    width: '100%',
    alignSelf: 'flex-end',
    // marginLeft: '20px',
    textAlign: 'left',
    marginTop: '1rem',
    [theme.breakpoints.down('sm')]: {
      width: '75%',
      marginTop: '1rem'
    }
  },
  imgDescrip: {
    width: '18em',
    marginLeft: '2rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginTop: '2.6rem'
    }
  },
  sup: {
    fontFamily: 'proximaNovaReg'
  },
  // ------------------------------------------------ mobile
  imgContM: {
    marginTop: '3.3rem',
    width: '100vw'
  },
  erikaImgM: {
    width: '100%'
  },
  imgCapM: {
    width: '75%',
    alignSelf: 'center',
    // marginRight: '20px',
    textAlign: 'center'
  },
  imgDescripM: {
    width: '75%',
    marginTop: '3.3rem'
  }
}));

const WhatIs = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));

  const mobileView = (
    <Grid container direction="column" alignItems="center" className={classes.mobileWrapper}>
      <Grid container item className={classes.textCont}>
        <Typography variant="h2" style={{ marginTop: '2.6rem' }}>
          What is Breast Cancer & How is it Typically Treated?
          <sup style={{ fontFamily: 'proximaNovaReg', fontSize: '1rem' }}>3</sup>
        </Typography>
        <Typography variant="body1" style={{ marginTop: '2.6rem' }}>
          Breast cancer occurs when normal cells in the breast change and grow uncontrollably.
          Although almost anyone can get it at any age, this disease is more common in women, and is
          often diagnosed after detecting a lump in the breast. Breast cancer is also commonly
          indicated in family health histories. Doctors use an X-ray known as a mammogram to check
          for breast cancer. If they discover a spot that appears to be cancer, a biopsy test is
          conducted by taking one or more small samples of tissue from the breast examining them for
          microscopic signs of the disease.
        </Typography>
        <Typography variant="body1" style={{ marginTop: '2.6rem' }}>
          Treatment depends on how far the cancer has spread, which is determined by cancer staging.
          There are a number of treatments for breast cancer, including surgery, radiation therapy,
          chemotherapy, hormone and targeted therapy, and immunotherapy. Women who have not
          developed cancer, but have been found to be at-risk can elect for preventative care such
          as a masectomy.
        </Typography>
      </Grid>
      <Grid item className={classes.imgContM}>
        <img src={erikaImg} alt="woman in wheelchair" className={classes.erikaImgM} />
      </Grid>
      <Typography variant="caption" className={classes.imgCapM}>
        Erika Stallings, the day she was discharged after her preventative masectomy.{' '}
      </Typography>
      <Typography variant="body1" className={classes.imgDescripM}>
        Women who’ve been treated for breast cancer need to be checked frequently in case the cancer
        comes back. These checks include more frequent mammograms as well as screening for symptoms
        like headaches, trouble breathing, and new lumps forming in the breast area.
      </Typography>
      <Typography variant="caption" className={classes.imgDescripM}>
        *The information provided is not intended to substitute for medical advice. Always consult
        your doctor in health related matters.
      </Typography>
    </Grid>
  );

  return (
    <>
      {matchesSM ? (
        mobileView
      ) : (
        <Grid container justifyContent="center" alignItems="center" className={classes.container}>
          <Grid container item className={classes.textCont}>
            <Typography variant="h2" style={{ marginTop: '2.6rem' }}>
              What is Breast Cancer & How is it Typically Treated?
            </Typography>
            <Typography variant="body1" style={{ marginTop: '2.6rem' }}>
              Breast cancer occurs when normal cells in the breast change and grow uncontrollably.
              Although almost anyone can get it at any age, this disease is more common in women,
              and is often diagnosed after detecting a lump in the breast. Breast cancer is also
              commonly indicated in family health histories. Doctors use an X-ray known as a
              mammogram to check for breast cancer. If they discover a spot that appears to be
              cancer, a biopsy test is conducted by taking one or more small samples of tissue from
              the breast examining them for microscopic signs of the disease.
            </Typography>
            <Typography variant="body1" style={{ marginTop: '2.6rem' }}>
              Treatment depends on how far the cancer has spread, which is determined by cancer
              staging. There are a number of treatments for breast cancer, including surgery,
              radiation therapy, chemotherapy, hormone and targeted therapy, and immunotherapy.
              Women who have not developed cancer, but have been found to be at-risk can elect for
              preventative care such as a masectomy.
            </Typography>
            <Grid container item className={classes.imgSec}>
              <Grid container direction="column" alignItems="flex-start">
                <img src={erikaImg} alt="woman in wheelchair" className={classes.erikaImg} />
                <Typography variant="caption" className={classes.imgCap}>
                  Erika Stallings, the day she was discharged after her preventative masectomy.{' '}
                </Typography>
              </Grid>
              <Grid
                container
                direction={matchesSM ? 'column' : 'row'}
                className={classes.imgDescrip}
              >
                <Typography variant="body1">
                  Women who’ve been treated for breast cancer need to be checked frequently in case
                  the cancer comes back. These checks include more frequent mammograms as well as
                  screening for symptoms like headaches, trouble breathing, and new lumps forming in
                  the breast area.
                </Typography>
                <Typography variant="caption">
                  *The information provided is not intended to substitute for medical advice. Always
                  consult your doctor in health related matters.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default WhatIs;
